import { NavRoute } from '../shared/navigation/nav.route.interface';
import { getReportsNav } from './nav-areas/reports-nav';
import { getEventsNav } from './nav-areas/events-nav';
import { getAdminNav } from './nav-areas/admin-nav';

export const getMainNavRoutes: () => NavRoute[] = function () {
	return [
		getEventsNav()
		, getAdminNav()
		, getReportsNav()
	];
};
